// frontend/src/pages/Login.jsx
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { adminLogin, vendorLogin, partnerLogin } from '../api/auth.api.js';
import { ErrorMessage } from '../components/ui';

const TABS = [
  { key: 'admin',   label: 'Admin' },
  { key: 'vendor',  label: 'Vendor' },
  { key: 'partner', label: 'Partner' },
];

export default function Login() {
  const [tab,      setTab]      = useState('admin');
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(null);

  const { login } = useAuth();
  const navigate  = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      let data;
      if (tab === 'admin')   data = await adminLogin({ email, password });
      if (tab === 'vendor')  data = await vendorLogin({ email, password });
      if (tab === 'partner') data = await partnerLogin({ email, password });

      login(data.accessToken, data.user);
      navigate('/dashboard');
    } catch (err) {
      // Show a friendlier message for unverified vendors
      if (err.data?.code === 'VENDOR_UNVERIFIED') {
        setError({ message: err.data.error });
      } else {
        setError(err);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">

        {/* Header */}
        <div className="text-center mb-8">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest">Rhaya Flicks</p>
          <h1 className="mt-1 text-3xl font-bold text-brand-700">Legal CRM</h1>
        </div>

        <div className="card p-8">
          {/* Tabs */}
          <div className="flex rounded-lg bg-gray-100 p-1 mb-6">
            {TABS.map((t) => (
              <button
                key={t.key}
                onClick={() => { setTab(t.key); setError(null); }}
                className={`flex-1 py-1.5 text-sm font-medium rounded-md transition-all ${
                  tab === t.key
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">Email</label>
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
                autoFocus
              />
            </div>

            <div>
              <div className="flex items-center justify-between mb-1">
                <label className="label mb-0">Password</label>
                <Link
                  to="/forgot-password"
                  className="text-xs text-brand-500 hover:underline"
                >
                  Forgot password?
                </Link>
              </div>
              <input
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            {error && <ErrorMessage error={error} />}

            <button type="submit" disabled={loading} className="btn-primary w-full mt-2">
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

          {tab === 'vendor' && (
            <p className="mt-4 text-center text-sm text-gray-500">
              No account?{' '}
              <Link to="/register" className="text-brand-500 hover:underline font-medium">
                Register as Vendor
              </Link>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
